(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/fraction-payment/assets/javascripts/fraction-payment.js') >= 0) return;  svs.modules.push('/components/marketplace/fraction-payment/assets/javascripts/fraction-payment.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  BottomSheetIntersersect
} = svs.components.lbUi.bottomSheetIntersect;
const {
  selectors
} = svs.components.marketplaceData;
const {
  useLocation,
  useHistory
} = ReactRouterDOM;
const {
  breakpoints,
  useMediaQuery,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  useFocusTrap
} = svs.components.lbUtils;
const {
  PayButton,
  useTriggerPayment,
  useCantBuy,
  useHasReachedMaxFractionsPerMember
} = svs.components.marketplace.fractionPayment;
const {
  useCallback,
  useEffect,
  useRef
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  games
} = svs.components.marketplaceData;
const {
  PRIVATE,
  RETAILER
} = svs.components.marketplaceData.constants.groupTypeNames;
const {
  payFraction
} = svs.components.marketplaceData.fractionPayment.actions;
const {
  reducerStates
} = svs.components.marketplaceData.constants;
const {
  selectPurchaseState,
  selectPurchaseContainerId
} = svs.components.marketplaceData.selectors.fractionPayment;

const FractionPayment = _ref => {
  let {
    activatedDrawId,
    block,
    className,
    containerId,
    game,
    groupId,
    hasSelectNumberOfShares,
    hasSnackbar,
    isSmall,
    isBrowseGames
  } = _ref;
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const {
    releaseFocus
  } = useFocusTrap({
    refocus: true
  });
  const payButtonRef = useRef(null);
  const payBtnId = "pay-btn-".concat(containerId);
  const currentUserId = useSelector(state => state.customerId);
  const isCurrentUserAuthenticated = Boolean(currentUserId);
  const group = useSelector(state => selectors.teams.selectTeam(state, {
    id: groupId
  }));
  const isSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const {
    currentUserNumberOfShares,
    fractionPrice,
    maxFractionsPerMember,
    maxFractions,
    soldShares,
    isSoldOut,
    productId,
    name: gameName
  } = game;
  const {
    triggerPayment,
    clearPaymentTrigger
  } = useTriggerPayment(activatedDrawId, groupId, isCurrentUserAuthenticated);
  const fractionPaymentInProgress = useSelector(state => selectPurchaseState(state)) === reducerStates.LOADING;
  const purchaseContainerId = useSelector(state => selectPurchaseContainerId(state));
  const cantBuy = useCantBuy({
    group,
    fractionPaymentInProgress,
    game,
    currentUserNumberOfShares
  });
  const hasReachedMaxFractionsPerMember = useHasReachedMaxFractionsPerMember({
    group,
    maxFractions,
    maxFractionsPerMember,
    currentUserNumberOfShares
  });
  const isCurrentPurchaseContainer = fractionPaymentInProgress && purchaseContainerId === containerId;
  let numberOfSharesLeft = maxFractions - soldShares;
  if (group.type === PRIVATE) {
    if (typeof maxFractionsPerMember === 'number' && typeof currentUserNumberOfShares === 'number') {
      const userSharesLeft = maxFractionsPerMember - currentUserNumberOfShares;

      numberOfSharesLeft = Math.min(numberOfSharesLeft, userSharesLeft);
    }
  }

  const focusPayButtonWhenReady = useCallback(() => {
    try {
      const url = new URL(window.location.href);
      const refocusId = url.searchParams.get('refocusContainerId');
      if (refocusId && Number(refocusId) !== containerId) {
        return;
      }
    } catch (e) {
    }
    let attempts = 0;
    const maxAttempts = 20; 

    const tryFocus = () => {
      const refEl = payButtonRef.current;
      const el = refEl && document.contains(refEl) ? refEl : document.getElementById(payBtnId);
      if (el && document.contains(el)) {
        var _el$focus;
        (_el$focus = el.focus) === null || _el$focus === void 0 || _el$focus.call(el);
        return;
      }
      if (attempts++ < maxAttempts) {
        setTimeout(tryFocus, 50);
      }
    };

    requestAnimationFrame(tryFocus);
  }, [containerId, payBtnId]);

  const markRefocusTarget = useCallback(() => {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('refocusContainerId', String(containerId));
      history.replace(_objectSpread(_objectSpread({}, history.location), {}, {
        search: url.search,
        hash: url.hash
      }));
    } catch (e) {
    }
  }, [history, containerId]);
  const triggerPaymentFlow = useCallback(async function () {
    let numberOfShares = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if (fractionPaymentInProgress) {
      return;
    }

    markRefocusTarget();
    const userContextCallback = () => {
      if (group.type === RETAILER || isBrowseGames) {
        dispatch(games.actions.fetchActivatedDrawAction(groupId, activatedDrawId, containerId));
      } else if (group.type === PRIVATE) {
        dispatch(games.actions.fetchGameAction(groupId, containerId));
      }
      releaseFocus(document.body, () => {
        focusPayButtonWhenReady();
      });
    };
    dispatch(payFraction({
      userContextCallback,
      fractionData: {
        activatedDrawId,
        containerId,
        groupId,
        fractionPrice,
        productId,
        numberOfShares
      },
      trackingData: {
        groupName: group.name,
        gameName,
        typeOfGroup: group.type
      }
    }));
  }, [activatedDrawId, containerId, currentUserId, dispatch, fractionPrice, group.type, groupId, isBrowseGames, location.pathname, productId, releaseFocus, focusPayButtonWhenReady, markRefocusTarget]);
  useEffect(() => {
    if (triggerPayment) {
      clearPaymentTrigger();
      const savedNumberOfShares = Number(sessionStorage.getItem('pendingNumberOfShares')) || 1;
      sessionStorage.removeItem('pendingNumberOfShares');
      triggerPaymentFlow(savedNumberOfShares);
    }
  }, []);
  if (!hasSnackbar) {
    return React.createElement("div", {
      className: className
    }, React.createElement(PayButton, {
      block: block,
      cantBuy: cantBuy,
      dataContainerId: containerId,
      elemRef: payButtonRef,
      fractionPrice: fractionPrice,
      fractionPurchaseLoading: isCurrentPurchaseContainer,
      hasSelectNumberOfShares: hasSelectNumberOfShares,
      id: payBtnId,
      isSmall: isSmall,
      numberOfSharesLeft: numberOfSharesLeft,
      onClick: numberOfShares => triggerPaymentFlow(numberOfShares)
    }));
  }
  return React.createElement("div", {
    className: className
  }, isSmallDevice && !hasReachedMaxFractionsPerMember && !isSoldOut && React.createElement("div", {
    className: "snackbar-container"
  }, React.createElement(BottomSheetIntersersect, {
    intersectId: "snackbar-selector"
  }, React.createElement("div", {
    className: "margin-1"
  }, React.createElement(PayButton, {
    block: block,
    cantBuy: cantBuy,
    dataContainerId: containerId,
    elemRef: payButtonRef,
    fractionPrice: fractionPrice,
    fractionPurchaseLoading: isCurrentPurchaseContainer,
    hasSelectNumberOfShares: hasSelectNumberOfShares,
    id: payBtnId,
    isSmall: isSmall,
    numberOfSharesLeft: numberOfSharesLeft,
    onClick: numberOfShares => triggerPaymentFlow(numberOfShares)
  })))), React.createElement("div", {
    className: className,
    "data-testid": "qa-fraction-snackbar",
    id: "snackbar-selector"
  }, React.createElement(PayButton, {
    block: block,
    cantBuy: cantBuy,
    dataContainerId: containerId,
    elemRef: payButtonRef,
    fractionPrice: fractionPrice,
    fractionPurchaseLoading: isCurrentPurchaseContainer,
    hasSelectNumberOfShares: hasSelectNumberOfShares,
    id: payBtnId,
    isSmall: isSmall,
    numberOfSharesLeft: numberOfSharesLeft,
    onClick: numberOfShares => triggerPaymentFlow(numberOfShares)
  })));
};
FractionPayment.defaultProps = {
  block: true,
  className: '',
  hasSelectNumberOfShares: false,
  hasSnackbar: false,
  isSmall: false
};

setGlobal('svs.components.marketplace.fractionPayment.FractionPayment', FractionPayment);

 })(window);